/* global API, Site, I18n */

import { createApp } from 'vue';
import Paginate from 'vuejs-paginate-next';
import { directive } from 'vue3-click-away';
import ld from 'lodash';
let _ = ld.noConflict();

import {
	useQuery,
	useGetTitle,
	useGetDesc,
	useGetCount,
	useCreateParams,
	useGetHref,
	useGetParams,
	useChangeFormat,
} from './composables/data';

import {
	useSuggestedKeywords,
	useGetKeywords,
	useSelectKeyword,
	useNavigateKeywords,
	useAddSearchKeyword,
	useKeywordClick,
} from './composables/keywords';

import { useOpenEmbed, useCloseEmbed, useEmbedData, useCreateEmbed, useCopyEmbed } from './composables/embed';
import { usePaginationData, usePages, useChangePage, usePageStart, usePageEnd } from './composables/paging';
import { useOnClickAway } from './composables/new';

// Vue element
const vueSelector = '.vue-search-lajikortit';
const vueElement = document.querySelector(vueSelector);

if (vueElement) {
	const app = createApp({
		directives: {
			ClickAway: directive,
		},
		components: {
			Paginate,
		},
		data() {
			return {
				lang: 'fi',
				results: {},
				format: 'list-format',
				data: {
					keywords: [],
				},
				helpers: {
					loading: true,
					showKeywords: false,
					keyword: '',
				},
				termCounts: {},
				useQuery,
				emptyQuery: _.cloneDeep(useQuery),
				usePaginationData,
				embed: false,
				useEmbedData,
				showPostType: false,
			};
		},
		computed: {
			/**
			 * Is the app currently loading?
			 * @returns {boolean} True if loading, false if not
			 */
			loading() {
				if (this.helpers.loading) {
					return true;
				}

				return false;
			},
		},
		async mounted() {
			this.lang = Site.lang_slug;

			// Set the search params from the URL
			this.useGetParams();

			// Setup the pagination data
			this.usePaginationData.postsPerPage = 10;

			// Get the keywords
			this.useGetKeywords();
		},
		methods: {
			/**
			 * Hakufunktio
			 * @param {boolean} log Logataanko haku vai ei
			 */
			search(log = false) {
				this.helpers.loading = true;

				this.useQuery.log = log;
				this.useQuery.post_type = 'lajikortit';

				this.useQuery.posts_per_page = 100;
				this.useQuery.taxonomies = true;

				// Reset the pagination page to 1
				this.usePaginationData.page = 1;

				this.useQuery.meta_query.hakusana = this.helpers.keyword;

				const deepCopy = _.cloneDeep(this.useQuery);

				this.useCreateParams('lajikortit', deepCopy);

				fetch(`${API.url}/search/lajikortit`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'X-WP-Nonce': API.nonce,
					},
					body: JSON.stringify(deepCopy),
				})
					.then((res) => res.json())
					.then((response) => {
						this.results.lajikortit = response;

						this.termCounts = response.term_counts || {};

						this.helpers.loading = false;
					})
					.catch((error) => console.error(error));
			},
			empty() {
				this.useQuery = _.cloneDeep(this.emptyQuery);

				this.search();
			},
			getTermCount(tax, termId) {
				let unitText;

				unitText = I18n.unitText;

				let count = 0;

				if (this.termCounts?.[tax]?.[termId]) {
					count = this.termCounts[tax][termId];
				}

				return '(' + count + ' ' + unitText + ')';
			},
			getTermCounts(tax) {
				const results = this.results?.lajikortit?.results;
				const taxonomies = this.results?.lajikortit?.taxonomies;

				if (taxonomies?.[tax]) {
					const terms = taxonomies[tax];

					terms.forEach((term) => {
						this.termCounts[term.term_id] = {
							term_id: term.term_id,
							count: 0,
						};
					});

					results?.forEach((result) => {
						if (!result.taxonomies[tax]) {
							return;
						}

						const resultTerms = result.taxonomies[tax];

						resultTerms.forEach((resultTerm) => {
							this.termCounts[resultTerm.term_id].count += 1;
						});
					});
				}
			},
			secondSearch(index, fetchId) {
				const deepCopy = JSON.parse(JSON.stringify(this.useQuery));

				deepCopy.posts_per_page = 100;
				deepCopy.is_initial = false;

				fetch(`${API.url}/search`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'X-WP-Nonce': API.nonce,
					},
					body: JSON.stringify(deepCopy),
				})
					.then((res) => res.json())
					.then((response) => {
						if (!this.fetches[fetchId].done) {
							this.results[index] = response;
						}
					})
					.catch((error) => console.error('Error', error))
					.finally(() => {
						// fetch on valmis
						this.fetchesLoading[index] = false;
						this.fetches[fetchId].done = true;
					});
			},
			useChangeFormat,
			usePageStart,
			usePageEnd,
			useChangePage,
			usePages,
			useGetKeywords,
			useNavigateKeywords,
			useSelectKeyword,
			useSuggestedKeywords,
			useAddSearchKeyword,
			useKeywordClick,
			useOnClickAway,
			useGetTitle,
			useGetDesc,
			// useGetShortDesc,
			// useHasShortDesc,
			useGetHref,
			useOpenEmbed,
			useCloseEmbed,
			useCreateEmbed,
			useCopyEmbed,
			useGetParams,
			useCreateParams,
			useGetCount,
		},
	});

	app.mount(vueSelector);
}
